import React, { Component } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { motion } from 'framer-motion';
import { getInformation, getItems, findInfoValue } from '../api';
import './Contact.css';

const containerStyle = {
  width: '100%',
  height: '400px',
  margin: '0 auto',
};

const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      when: 'beforeChildren',
      staggerChildren: 0.3,
    },
  },
};

export default class Contact extends Component {
  state = {
    informationData: [],
    loading: true,
    error: null,
    copied: false,
  };

  componentDidMount() {
    getInformation()
      .then((response) => {
        this.setState({ informationData: getItems(response), loading: false });
      })
      .catch(() => {
        this.setState({ error: '정보를 가져오는 데 실패했습니다.', loading: false });
      });
  }

  valueOf = (key, fallback = '미등록') =>
    findInfoValue(this.state.informationData, key, fallback);

  copyEmail = async () => {
    const inquiryEmail = this.valueOf('email', '');
    if (!inquiryEmail) return;
    try {
      await navigator.clipboard.writeText(inquiryEmail);
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 2000);
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { loading, error, copied } = this.state;
    if (loading) return <div>Loading contact information...</div>;
    if (error) return <div>{error}</div>;

    const inquiryEmail = this.valueOf('email', '');
    const mapLat = parseFloat(this.valueOf('map_lat', '')) || 37.2332754174924;
    const mapLng = parseFloat(this.valueOf('map_lng', '')) || 127.023471864064;

    return (
      <div>
        <motion.div initial="hidden" animate="visible" variants={containerVariants}>
          <div className="google-map-container">
            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
              <GoogleMap mapContainerStyle={containerStyle} center={{ lat: mapLat, lng: mapLng }} zoom={15}>
                <Marker position={{ lat: mapLat, lng: mapLng }} />
              </GoogleMap>
            </LoadScript>
          </div>
          <motion.section className="contact-container" initial="hidden" animate="visible" variants={containerVariants}>
            <article className="waytocome-item_title">
              <dt>{this.valueOf('company_name')}</dt>
              <dd className="waytocome-address">
                <span>{this.valueOf('address')}</span>
              </dd>
            </article>
            <article className="waytocome-item_callnum">
              <dt>전화</dt>
              <dd>{this.valueOf('phone')}</dd>
            </article>
            <article className="waytocome-item_fax">
              <dt>팩스</dt>
              <dd>{this.valueOf('fax')}</dd>
            </article>
            <article className="waytocome-item-email">
              <dt>이메일</dt>
              <dd>{inquiryEmail || '미등록'}</dd>
            </article>
          </motion.section>
          <motion.section className="email-form" initial="hidden" animate="visible" variants={containerVariants}>
            <h3>문의하기</h3>
            {inquiryEmail ? (
              <div className="inquiry-email-box">
                <p>아래 메일 주소로 직접 문의해 주세요.</p>
                <a href={`mailto:${inquiryEmail}`}>{inquiryEmail}</a>
                <button type="button" onClick={this.copyEmail}>
                  {copied ? '복사됨' : '주소 복사'}
                </button>
              </div>
            ) : (
              <p>등록된 문의 메일이 없습니다.</p>
            )}
          </motion.section>
        </motion.div>
      </div>
    );
  }
}
